module.exports = __webpack_public_path__ + "static/img/bodyimg.1d6af1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bodyimg.jpg
// module id = 7dua
// module chunks = 1